import { UploadUserFile } from 'element-plus';

export type SubRole = Record<
  string,
  {
    show: boolean;
    value: string;
  }
>;

export interface uploadFileType {
  name?: string;
  url?: string;
  uri?: string;
}
export interface FilesType {
  urlFile?: uploadFileType[];
  photoFile?: uploadFileType[];
}

export type ICommunityProfileData = defs.dtsServer.DtsCommunityProfileHistoryVo & FilesType;

export enum RoleType {
  STEWARD = '1',
  ENGINEER = '2',
}

export const roleOptions = [
  {
    label: 'Data Steward',
    value: RoleType.STEWARD,
  },
  {
    label: 'Data Engineer',
    value: RoleType.ENGINEER,
  },
];

export enum ResourceEnum {
  NAME_LIST = 1,
  IMAGE = 2,
}

export const resourceOptions = [
  {
    value: ResourceEnum.NAME_LIST,
    label: 'Name List',
  },
  {
    value: ResourceEnum.IMAGE,
    label: 'Image',
  },
];

export interface TableType {
  rows: defs.dtsServer.DtsCommunityProfileHistoryVo[];
  total: number;
}

export enum ActionType {
  SAVE = 1,
  SUBMIT,
  DELETE,
  EDIT,
  TABLE,
}

export enum ManageEnum {
  ON_GOING = 1,
  DEPRECATE = 2,
}
